import React from 'react';
import { connect } from 'react-redux';
import { AlTemplateOtherRow } from 'PatientCareCenter/Note/AL/Templates';
import styles from './Common.module.css';


class AlTemplateOther extends React.Component {

    render() {
        if (this.props.activities.length > 0) {
            return (
                <div className={styles.section_wrapper}>
                    <div className={styles.header_row}>Other</div>

                    {Object.keys(this.props.activities)
                        .map(key => {
                            const result = this.props.activities[key];
                            return (
                                <AlTemplateOtherRow key={result.XLTMPOENO} id={result.XLTMPOENO} />
                            )
                        })
                    }
                </div>
            );
        } else {
            return (<span />);
        }
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;

    return {
        activities: state.entities.notes.MLTMPOTHER ?
            Object.keys(state.entities.notes.MLTMPOTHER)
                .filter(key => {
                    return (state.entities.notes.MLTMPOTHER[key].NoteId === noteId)
                })
                .sort((a, b) => state.entities.notes.MLTMPOTHER[a].XLTMPOEORDER - state.entities.notes.MLTMPOTHER[b].XLTMPOEORDER)
                .map(key => state.entities.notes.MLTMPOTHER[key]) : [],
    };
}

const connectedAlTemplateOther = connect(mapStateToProps)(AlTemplateOther);
export { connectedAlTemplateOther as AlTemplateOther };

